interface LoadingSpinnerProps {
  message?: string;
}

export function LoadingSpinner({ message }: LoadingSpinnerProps) {
  return (
    <div className="flex min-h-[200px] flex-col items-center justify-center gap-4">
      <div className="size-12 animate-spin rounded-full border-b-2 border-red-600"></div>
      {message && <p className="text-gray-600">{message}</p>}
    </div>
  );
}
